<template src="./sidebar.component.html"></template>
<style scoped src="./sidebar.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import {logout} from '@/helpers';

export default Vue.extend({
  data() {
    return {};
  },
  methods: {
    async logout() {
      logout();
      await this.$router.push('/login');
    },
  },
});
</script>
